import React, { Component } from 'react'
import SimpleTabs from './components/CompletedListTabPanel';

class CompletedListTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default CompletedListTab
  